import PlaylistsCards from './PlaylistsCards';

export default PlaylistsCards;
